import { FilterType, type Filter } from '../types/filter'
import type { CustomerFilter } from '../types/customer-filter'

function valueOf(filters: Filter[], key: FilterType) {
  return filters.find(f => f.key === key)?.value
}

export function customerFilterTemplate(): Filter[] {
  return [
    { key: FilterType.subscriptionStatus, label: 'Subscription Status' },
    { key: FilterType.customerTag, label: 'Customer Tag' },
    { key: FilterType.partner, label: 'Partner' },
    { key: FilterType.policyHolder, label: 'Policy Holder' },
    { key: FilterType.age, label: 'Age' },
    { key: FilterType.gender, label: 'Gender' },
    { key: FilterType.country, label: 'Country' },
    { key: FilterType.switchedCalls, label: 'Non-member switches' },
  ]
}

export function chipsToCustomerFilter(filters: Filter[]): CustomerFilter {
  const cf: CustomerFilter = {}
  const status = valueOf(filters, FilterType.subscriptionStatus)
  if (status?.length) cf.subscription_status = status
  const partners = valueOf(filters, FilterType.partner)
  if (partners?.length) cf.partners = partners
  const policyHolders = valueOf(filters, FilterType.policyHolder)
  if (policyHolders?.length) cf.policy_holders = policyHolders
  const tags = valueOf(filters, FilterType.customerTag)
  if (tags?.length) cf.tags = tags
  const age = valueOf(filters, FilterType.age)
  if (age && (age.min != null || age.max != null)) cf.age = age
  const gender = valueOf(filters, FilterType.gender)
  if (gender?.length) cf.gender = gender
  const country = valueOf(filters, FilterType.country)
  if (country?.values?.length) cf.country = { values: country.values, exclude: !!country.exclude }
  const switchedCalls = valueOf(filters, FilterType.switchedCalls)
  if (switchedCalls != null) cf.min_switched_calls = switchedCalls
  return cf
}

export function customerFilterToChips(cf: CustomerFilter, template: Filter[]): Filter[] {
  return template.map((t) => {
    const chip: Filter = { ...t, value: undefined, selected: undefined }
    switch (t.key) {
      case FilterType.subscriptionStatus: {
        const s = cf.subscription_status as unknown
        if (s) chip.value = Array.isArray(s) ? s : [s]
        break
      }
      case FilterType.partner: if (cf.partners?.length) chip.value = cf.partners; break
      case FilterType.policyHolder: if (cf.policy_holders?.length) chip.value = cf.policy_holders; break
      case FilterType.customerTag: if (cf.tags?.length) chip.value = cf.tags; break
      case FilterType.age: if (cf.age) chip.value = cf.age; break
      case FilterType.gender: if (cf.gender?.length) chip.value = cf.gender; break
      case FilterType.country: if (cf.country?.values?.length) chip.value = cf.country; break
      case FilterType.switchedCalls: if (cf.min_switched_calls != null) chip.value = cf.min_switched_calls; break
    }
    return chip
  })
}
